export default [
    {
        path: '/pages/property/downloadTempFile',
        name: '/pages/property/downloadTempFile',
        meta: { title: '下载中心' },
        component: () => import('@/views/property/downloadTempFile.vue')
    },
    {
        path: '/pages/property/propertyDeductionReport',
        name: '/pages/property/propertyDeductionReport',
        meta: { title: '抵扣金管理报表' },
        component: () => import('@/views/property/propertyDeductionReport.vue')
    },
    {
        path: '/pages/property/propertyDeductionRebateConfig',
        name: '/pages/property/propertyDeductionRebateConfig',
        meta: { title: '物业费抵扣金设置' },
        component: () => import('@/views/propertyDeduction/propertyDeductionRebateConfig.vue')
    },
    {
        path: '/pages/property/useRatioConfig',
        name: '/pages/property/useRatioConfig',
        meta: { title: '抵扣金使用比例配置' },
        component: () => import('@/views/propertyDeduction/useRatioConfig.vue')
    },
    {
        path: '/pages/property/shareRatioConfig',
        name: '/pages/property/shareRatioConfig',
        meta: { title: '抵扣金成本分担比例配置' },
        component: () => import('@/views/propertyDeduction/shareRatioConfig.vue')
    },
    {
        path: '/pages/property/useRatioConfig',
        name: '/pages/property/useRatioConfig',
        meta: { title: '抵扣金使用比例' },
        component: () => import('@/views/propertyDeduction/useRatioConfig.vue')
    },
    {
        path: '/pages/property/shareRatioConfig',
        name: '/pages/property/shareRatioConfig',
        meta: { title: '抵扣金成本分担' },
        component: () => import('@/views/propertyDeduction/shareRatioConfig.vue')
    }
] 